import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import { history } from '../../../store';

import * as storage from '../../../persistance/storage';

import {displayPhone, displayDateFromTimestamp, displaySimpleDate, getDiamondImage, formatDiamondTitle, formatMeasurements, formatLocation, formatCut, formatCarat, formatCost, formatColor, formatPrice, formatClarity, displayVerboseDateFromTimestamp, displayDateMMDD, getUrlId, breaksToBrs} from '../../../utils/formatting';

import * as api from '../../../constants/api';

import RhinoLoading from '../common/RhinoLoading';
import RhinoCheckbox from '../../common/inputs/RhinoCheckbox';
import RhinoModal from '../../common/modal/RhinoModal';
import RhinoConfirm from '../../common/confirm/RhinoConfirm';

import * as commonActionCreators from '../../../actions/common';
import * as headerActionCreators from '../../../actions/header';
import * as leadsActionCreators from '../../../actions/leads';
import * as messagesActionCreators from '../../../actions/messages';
import * as usersActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, commonActionCreators, headerActionCreators, leadsActionCreators, messagesActionCreators, usersActionCreators);


class SingleLead extends React.Component {

  constructor(props) {
    super(props);

    this.cardId = parseInt(getUrlId());

    this.state = {
      selectedDiamonds: [],
      cardId: this.cardId,
      card: null,
      cardDiamonds: [], 
      includeGia: false,
      includePrice: false,
      includeImage: false,
      includeVideo: false,
      message: '',
      showShareModal: false,
      showMessageModal: false,

      externalShare: null,
      shareError: null,

      transferModalOpen: false,
      holdModalOpen: false,
      transferMessage: '',

      transferApptDate: '', 
      transferApptDateError: '',

      holdMessage: '',

      notesPending: true,
      notesData: [],
      notesAddVisible: false,
      inputAddNote: '',

      diamondsPending: true,
      diamondsData: [],

      noteToDelete: null,
      noteToEdit: null,

      deleteModalOpen: false,
      editModalOpen: false,

      noteBody: '', 
    }
  }

  componentDidMount() {
    if(this.state.card === null) {

      let emailQuery = window.location.search;

      this.props.fetchFullCard(this.cardId)
      .then((respData) => {

        this.setState({ 
          card: respData,
          includeGia: false,
          includePrice: false,
          includeImage: false,
          includeVideo: false,
        }, () => {
          this.fetchNotes();
          // this.fetchDiamonds();
        });
      })
      // .catch((errorResp) => {
      //   console.error(errorResp);
      // });


    }
  }

  fetchNotes() {
    if(this.state.card.id) {

      this.setState({ notesPending: true });

      this.props.userCustomerFetchNotes(this.state.card.id)
      .then((respData) => {
        this.setState({ 
          notesPending: false,
          notesData: respData,
        });
      })
      .catch((err) => {
        this.setState({ 
          notesPending: false,
          notesData: [],
        });
      })
    }
  }

  fetchDiamonds() {

    if(this.state.card.id) {

      this.setState({ diamondsPending: true });

      this.props.userCardDiamondsFetch(this.state.card.id)
      .then((respData) => {
        this.setState({ 
          diamondsPending: false,
          diamondsData: respData.diamonds,
        });
      })
    }
  }

  userNav(page) {
    history.push('/' + page);
  }

  getAddressOne() {
    if(!this.state.card) {
      return '';
    }
    if(this.state.card.address_street) {
      return this.state.card.address_street;
    }
    if(this.state.card.address_city && this.state.card.address_state) {
      return this.state.card.address_city + ', ' + this.state.card.address_state;
    }
    if(this.state.card.address_city) {
      return this.state.card.address_city;
    }
    if(this.state.card.address_state) {
      return this.state.card.address_state;
    }
    return '';
  }

  getAddressTwo() {
    if(!this.state.card) {
      return '';
    }
    if(this.state.card.address_street) {
      if(this.state.card.address_city && this.state.card.address_state) {
        return this.state.card.address_city + ', ' + this.state.card.address_state;
      }
      if(this.state.card.address_city) {
        return this.state.card.address_city;
      }
      if(this.state.card.address_state) {
        return this.state.card.address_state;
      }
    }
    return '';
  }

  getSoName() {
    if(!this.state.card || !this.state.card.spouses) {
      return '';
    }
    if(this.state.card.spouses[0].first_name && this.state.card.spouses[0].last_name) {
      return this.state.card.spouses[0].first_name + ' ' + this.state.card.spouses[0].last_name;
    }
    if(this.state.card.spouses[0].first_name) {
      return this.state.card.spouses[0].first_name;
    }
    if(this.state.card.spouses[0].last_name) {
      return this.state.card.spouses[0].last_name;
    }
    return '';
  }

  toggleIncludeGia() {
    this.setState({ includeGia: !this.state.includeGia });
  }

  toggleIncludePrice() {
    this.setState({ includePrice: !this.state.includePrice });
  }

  toggleIncludeImage() {
    this.setState({ includeImage: !this.state.includeImage });
  }

  toggleIncludeVideo() {
    this.setState({ includeVideo: !this.state.includeVideo });
  }

  isSelected(diamond) {
    return this.state.selectedDiamonds.indexOf(diamond.id) > -1;
  }

  toggleSelected(diamond) {

    let clone = this.cloneArray(this.state.selectedDiamonds);
    let i = this.state.selectedDiamonds.indexOf(diamond.id);
    if(i > -1) {
      clone.splice(i, 1);
    } else {
      clone.push(diamond.id);
    }

    this.setState({
      selectedDiamonds: clone,
    });
  }

  openShareModal() {

    this.closeMessageModal();

    let shareData = {
      card_id: this.state.cardId,
      diamonds: this.state.selectedDiamonds,
      include_gia: this.state.includeGia,
      include_price: this.state.includePrice,
      include_image: this.state.includeImage,
      include_video: this.state.includeVideo,
      message: this.state.message,
    }

    this.props.leadsCreateExternal(shareData)
    .then((respData) => {
      this.setState({ 
        externalShare: respData.share,
      });
    })
    .catch((errorResp) => {
      console.error(errorResp);
      this.setState({
        shareError: errorResp.message,
      });
    });


    this.setState({ showShareModal: true });
  }

  closeShareModal() {
    this.setState({ 
      showShareModal: false, 
      externalShare: null,
      shareError: null,
    });
  }

  openMessageModal() {
    this.setState({
      showMessageModal: true,
      message: '',
    });
  }

  closeMessageModal() {
    this.setState({ 
      showMessageModal: false, 
    });
  }

  changeMessage(evt) {
    this.setState({ message: evt.target.value })
  }

  cloneArray(source) {
    let result = [];
    for(let n = 0; n < source.length; n++) {
      result[n] = source[n];
    }
    return result;
  }

  removeDiamond(diamond) {

    let removeData = {
      card_id: this.state.cardId,
      diamonds: [diamond.id],
    }

    this.setState({
      sendingRequest: true,
      serverError: null,
    });

    this.props.leadsRemoveDiamonds(removeData)
    .then((respData) => {
      
      this.props.leadsCloseAddDropdown();

      this.setState({
        selectedDiamonds: [],
        // card: respData.card,
      });
      this.fetchDiamonds();
    })
    .catch((errorResp) => {
      // console.error(errorResp);
      this.setState({
        sendingRequest: false,
        serverError: errorResp.message,
      });
    });
  }

  editCard() {

    // if(!this.state.card.customer_number) {
    //   this.props.commonAlert("Customer still saving in ASC, please wait a few minutes before editing.");
    // } else {
    //   this.props.setCustomerCardToEdit(this.state.card);
    //   setTimeout(() => {
    //     this.userNav('customer-profile');
    //   }, 50);
    // }
    let win = window.open(api.CUSTOMER_CREATE_URL, '_blank');
    win.focus();
  }

  shareExternalSubmit() {

    let shareData = {
      card_id: this.state.cardId,
      diamonds: this.state.selectedDiamonds,
      include_gia: this.state.includeGia,
      include_price: this.state.includePrice,
      include_image: this.state.includeImage,
      include_video: this.state.includeVideo,
      message: this.state.message,
    }

    if(this.state.card.email) {
      shareData["email"] = this.state.card.email;
    }

    this.props.leadsShareExternal(shareData)
    .then((respData) => {
      this.setState({ 
        selectedDiamonds: [],
        includeGia: false,
        includePrice: false,
        includeImage: false,
        includeVideo: false,
      });
      this.props.messagesShowConfirmation('Customer card shared');
    })
    // .catch((errorResp) => {
    //   console.error(errorResp);
    // });
    this.closeShareModal();
  }

  holdAll() {
    this.setState({ holdModalOpen: true });
  }

  transferAll() {
    this.setState({ transferModalOpen: true });
  }

  sendHoldRequest() {
    let confirmationMessage = 'Hold requests sent';
    if(this.state.selectedDiamonds.length === 1) {
      confirmationMessage = 'Hold request sent';
    }
    this.props.messagesShowConfirmation(confirmationMessage);
    this.setState({
      holdModalOpen: false,
    }, () => {

      let holdData = {
        diamonds: this.state.selectedDiamonds,
        message_body: this.state.holdMessage,
      }

      this.props.messagesSendHoldReq(holdData)
      .then((respData) => {
        // Do nothing
      })
      // .catch((errorResp) => {
      //   console.error(errorResp);
      // });
    });
  }

  validateTransfer() {
    if(!this.state.transferApptDate) {
      this.setState({
        transferApptDateError: 'Please enter an appointment date',
      });
      return false;
    }
    return true;
  }

  sendTransferRequest() {

    // if(this.validateTransfer() === false) {
    //   return null;
    // }

    let confirmationMessage = 'Transfer requests sent';
    if(this.state.selectedDiamonds.length === 1) {
      confirmationMessage = 'Transfer request sent';
    }
    this.props.messagesShowConfirmation(confirmationMessage);
    this.setState({
      transferModalOpen: false,
    }, () => {

      let transferData = {
        diamonds: this.state.selectedDiamonds,
        message_body: this.composeTransferMessage(),
        appointment_date: this.state.transferApptDate,
      }

      this.props.messagesSendTransferReq(transferData)
      .then((respData) => {
        // Do nothing
      })
      // .catch((errorResp) => {
      //   console.error(errorResp);
      // });
    });
  }

  changeTransferName(evt) {
    this.setState({ transferName: evt.target.value });
  }

  changeTransferApptDate(evt) {
    this.setState({ transferApptDate: evt.target.value });
  }

  changeTransferApptTime(evt) {
    this.setState({ transferApptTime: evt.target.value });
  }

  changeTransferBudget(evt) {
    this.setState({ transferBudget: evt.target.value });
  }

  changeTransferMessage(evt) {
    this.setState({ transferMessage: evt.target.value });
  }

  composeTransferMessage() {
    let baseMessage = '';
    if(this.state.transferName !== '') {
      baseMessage = baseMessage + 'Customer name: ' + this.state.transferName + '\n';
    }
    if(this.state.transferApptDate !== '') {
      baseMessage = baseMessage + 'Appointment Date: ' + this.state.transferApptDate + '\n';
    }
    if(this.state.transferApptTime !== '') {
      baseMessage = baseMessage + 'Appointment Time: ' + this.state.transferApptTime + '\n';
    }
    if(this.state.transferBudget !== '') {
      baseMessage = baseMessage + 'Budget: ' + this.state.transferBudget + '\n';
    }
    if(this.state.transferMessage !== '') {
      baseMessage = baseMessage + 'Message: ' + this.state.transferMessage;
    }
    return baseMessage;
  }

  changeHoldMessage(evt) {
    this.setState({
      holdMessage: evt.target.value,
    });
  }

  closeTransferModal() {
    this.setState({ transferModalOpen: false });
  }

  closeHoldModal() {
    this.setState({ holdModalOpen: false });
  }

  openSendCustomer() {
    this.props.headerOpenSendLeadDropdown(this.state.card);
  }

  changeAddNote(evt) {
    this.setState({ inputAddNote: evt.target.value });
  }

  toggleAddNote() {
    this.setState({ notesAddVisible: !this.state.notesAddVisible }, () => {
      if(!this.state.notesAddVisible) {
        this.setState({ inputAddNote: '' });
      }
    });
  }

  addNoteSave() {
    if(!this.state.inputAddNote) {
      this.props.commonAlert("Notes cannot be empty. Please enter a note before saving.");
      return null;
    }

    const addNoteData = {
      body: this.state.inputAddNote.trim(), 
    }

    this.props.userCustomerAddNote(this.cardId, addNoteData)
    .then((respData) => {

      this.setState({ inputAddNote: '' });

      this.toggleAddNote();
      this.fetchNotes();
    })
    .catch((err) => {
      this.toggleAddNote();
      this.fetchNotes();
    });
  }

  isThisMine(note) {
    // const uid = storage.get('uid');
    // return note.author.id == uid;

    // No edit or delete endpoints
    return false;
  }

  confirmDelete(note) {
    this.setState({
      noteToDelete: note,
      deleteModalOpen: true, 
    });
  }

  handleDelete() {

    if(!this.state.noteToDelete || !this.state.noteToDelete.id) {
      return null;
    }

    const deleteNoteData = {
      note_id: this.state.noteToDelete.id, 
    }

    this.setState({ notesPending: true });

    this.props.userNotesDelete(deleteNoteData)
    .then((respData) => {
      // this.fetchNotes();
      this.closeDeleteModal();
    });
  }

  handleEdit() {

    if(!this.state.noteToEdit || !this.state.noteToEdit.id) {
      return null;
    }

    const editNoteData = {
      note_id: this.state.noteToEdit.id, 
      body: this.state.noteBody, 
    }

    this.setState({ notesPending: true });

    this.props.userNotesEdit(editNoteData)
    .then((respData) => {
      // this.fetchNotes();
      this.closeEditModal();
    });
  }

  openEditModal(note) {
    this.setState({
      noteToEdit: note,
      editModalOpen: true, 
      noteBody: note.body, 
    });
  }

  closeEditModal() {
    this.setState({
      noteToEdit: null,
      editModalOpen: false, 
      noteBody: '', 
    });
  }

  closeDeleteModal() {
    this.setState({
      noteToDelete: null,
      deleteModalOpen: false, 
    });
  }

  changeNoteBody(evt) {
    this.setState({
      noteBody: evt.target.value,
    })
  }

  render() {

    let base_url = api.FRONTEND_URL;

    return <div className='SingleLead'>
      {this.state.card === null ?
        <div className='leadLoading'>
          <RhinoLoading message='Loading customer' />
        </div> :
        <div>
          <div className='leadInfoBlockWrapper'>
            <div className='leadInfoBlock'>
              <div className='titleWrapper'>
                <div className='nameWrapper'>
                  <span>{this.state.card.firstName + ' ' + this.state.card.lastName}</span>
                </div>
                <div className='customerNumberWrapper'>{this.state.card.textCustomField25 ? this.state.card.textCustomField25 : ''}</div>
                <div className='createWrapper' style={{ display: 'none' }}>{displayVerboseDateFromTimestamp(this.state.card.lastModifiedAt)}</div>
                <div className='cityWrapper'>
                  {this.state.card.address ?
                    <div>{this.state.card.address}</div> :
                    null
                  }
                </div>
                <button className={'editCardButton secondaryButton'} onClick={this.editCard.bind(this)}>Edit Card</button>
                <button className={'addDiamondsButton secondaryButton'} onClick={() => this.userNav('diamonds')} style={{ display: 'none' }}>Add Diamonds</button>
                <div className='shareArrowWrapper' onClick={this.openSendCustomer.bind(this)} style={{display: 'none'}}>
                  <div className='shareImgWrapper'>
                    <img src='/img/singlediamond/share.svg' />
                  </div>
                  <div className='shareLabelWrapper'>share</div>
                </div>
              </div>
              <div className='salespersonWrapper'>
                {this.state.card.details && this.state.card.details.assigned_sales_person_id ?
                  <div className='salesElement'>
                    <div className='spLabel'>Salesperson #:</div>
                    <div className='spValue'>{this.state.card.details.assigned_sales_person_id}</div>
                  </div> :
                  null
                }
              </div>
              <div className='detailsWrapper'>
                <div className='userDetails'>
                  <div className={'detailsItem'}>
                    <div className='detailsIcon' style={{height: '14px'}}><img src='/img/card/email.svg' /></div>
                    <div className={'detailsValue'}>{this.state.card.email ? this.state.card.email : 'n/a'}</div>
                  </div>
                  {this.getAddressOne() === '' && this.getAddressTwo() === '' ?
                    <div className={'detailsItem'}>
                      <div className='detailsIcon'>&nbsp;</div>
                      <div className='detailsValue'>&nbsp;</div>
                    </div> :
                    <div className={'detailsItem'}>
                      <div className='detailsIcon'><i className="fas fa-map-marker-alt"></i></div>
                      <div className='detailsValue'>{this.getAddressOne()}</div>
                    </div>
                  }
                  {this.state.card.phone ?
                    <div className='detailsItem'>
                      <div className='detailsIcon'><img src='/img/card/phone.svg' /></div>
                      <div className='detailsValue'>{this.state.card.phone ? displayPhone(this.state.card.phone) : 'n/a'}</div>
                    </div> :
                    null
                  }
                  {this.state.card.app_ring_size && false ?
                    <div className='detailsItem'>
                      <div className='detailsIcon' style={{height: '15px'}}><img src='/img/card/ringsize.svg' /></div>
                      <div className='detailsValue'>{this.state.card.app_ring_size ? parseFloat(this.state.card.app_ring_size).toFixed(2) : 'n/a'}</div>
                    </div> :
                    null
                  }
                  {this.state.card.date_of_birth && false ?  
                    <div className='detailsItem'>
                      <div className='detailsIcon'><img src='/img/card/bday.svg' /></div>
                      {this.state.card.date_of_birth.length <= 5 ?
                        <div className='detailsValue'>{displayDateMMDD(this.state.card.date_of_birth)}</div> :
                        <div className='detailsValue'>{displayDateMMDD(this.state.card.date_of_birth)}</div>
                      }
                    </div> :
                    <div className='detailsItem' style={{ display: 'none' }}>
                      <div className='detailsIcon'><img src='/img/card/bday.svg' /></div>
                      <div className='detailsValue'>n/a</div>
                    </div>
                  }
                  {this.state.card.anniversary_date && false ?
                    <div className='detailsItem'>
                      <div className='detailsIcon' style={{height: '14px'}}><img src='/img/card/anniversary.svg' /></div>
                      {this.state.card.anniversary_date.length <= 5 ?
                        <div className='detailsValue'>{displayDateMMDD(this.state.card.anniversary_date)}</div> :
                        <div className='detailsValue'>{displayDateMMDD(this.state.card.anniversary_date)}</div>
                      }
                    </div> :
                    <div className='detailsItem' style={{ display: 'none' }}>
                      <div className='detailsIcon' style={{height: '14px'}}><img src='/img/card/anniversary.svg' /></div>
                      <div className='detailsValue'>n/a</div>
                    </div>
                  }
                </div>
                <div className='userDetails'>
                  {this.state.card.significant_other_name ?
                    <div className='detailsItem'>
                      <div className='detailsIcon' style={{height: '14px'}}><img src='/img/card/sigother.svg' /></div>
                      <div className='detailsValue'>{this.state.card.significant_other_name ? this.state.card.significant_other_name : 'n/a'}</div>
                    </div> :
                    null
                  }
                  {this.state.card.significant_other_birthday ?
                    <div className={'detailsItem'}>
                      <div className='detailsIcon'><img src='/img/card/bday.svg' /></div>
                      <div className='detailsValue'>{displayDateMMDD(this.state.card.significant_other_birthday)}</div>
                    </div> :
                    <div className={'detailsItem'}>
                      <div className='detailsIcon'><img src='/img/card/bday.svg' /></div>
                      <div className='detailsValue'>n/a</div>
                    </div>
                  }
                  {this.state.card.spouses && this.state.card.spouses.length && this.state.card.spouses[0].finger_size ?
                    <div className='detailsItem'>
                      <div className='detailsIcon' style={{height: '15px'}}><img src='/img/card/ringsize.svg' /></div>
                      <div className='detailsValue'>{parseFloat(this.state.card.spouses[0].finger_size).toFixed(2)}</div>
                    </div> :
                    <div className='detailsItem' style={{ display: 'none' }}>
                      <div className='detailsIcon' style={{height: '15px'}}><img src='/img/card/ringsize.svg' /></div>
                      <div className='detailsValue'>n/a</div>
                    </div>
                  }
                </div>
              </div>
              <div className='associateWrapper'>
                <div className='associateLabel' style={{display: 'none'}}>Sales Associate:</div>
                <div className='associateValue' style={{display: 'none'}}>{''}</div>
              </div>
              <div className='notesWrapper'>
                <div className='notesBody'>
                  {this.state.notesPending ?
                    <div className='loadingWrapper'>Loading notes...</div> :
                    <div>
                      {this.state.notesData && this.state.notesData.length === 0 ?
                        <div>
                          <div className='nullWrapper'>No notes found</div>
                          {this.state.notesAddVisible ?
                            <div className='addNoteInputWrapper'>
                              <textarea
                                className='addNoteInput'
                                value={this.state.inputAddNote}
                                onChange={this.changeAddNote.bind(this)}
                                placeholder='Enter customer note'></textarea>
                              <div className='addNoteButtonWrapper'>
                                <button
                                  className='noteButton'
                                  type='button'
                                  onClick={this.toggleAddNote.bind(this)}>Cancel</button>
                                <button
                                  className='noteButton'
                                  type='button'
                                  onClick={this.addNoteSave.bind(this)}>Add Note</button>
                              </div>
                            </div> :
                            <div style={{textAlign: 'center', marginBottom: '10px'}}>
                              <button type='button' className='noteButton' onClick={this.toggleAddNote.bind(this)}>Add Note</button>
                            </div>
                          }
                        </div> :
                        <div>
                          <div className='foundWrapper'>
                            <div className='foundBody'>
                              <div className='foundList'>
                                {this.state.notesData.map((note, i) => {
                                  return <div className='singleNote' key={i}>
                                    <div className='snHeader'>
                                      <div className='snhName'>{note.createdBy.firstName + ' ' + note.createdBy.lastName}</div>
                                      <div className='snhDate'>{displayDateFromTimestamp(note.createdAt)}</div>
                                      {this.isThisMine(note) ?
                                        <div className='snhControls'>
                                          <div className='controlElement' onClick={() => this.openEditModal(note)}>
                                            <i className="fas fa-cog"></i>
                                          </div>
                                          <div className='controlElement' onClick={() => this.confirmDelete(note)}>
                                            <i className="fas fa-trash"></i>
                                          </div>
                                        </div> :
                                        null
                                      }
                                    </div>
                                    <div 
                                      className='snBody'
                                      dangerouslySetInnerHTML={{
                                        __html: breaksToBrs(note.object.note || '', { margin: '0 0 5px 0' }),
                                      }} />
                                  </div>
                                })}
                              </div>
                              {this.state.notesAddVisible ?
                                <div className='addNoteInputWrapper' style={{paddingLeft: '0', paddingRight: '0'}}>
                                  <textarea
                                    className='addNoteInput'
                                    value={this.state.inputAddNote}
                                    onChange={this.changeAddNote.bind(this)}
                                    placeholder='Enter customer note'></textarea>
                                  <div className='addNoteButtonWrapper'>
                                    <button
                                      className='noteButton'
                                      type='button'
                                      onClick={this.toggleAddNote.bind(this)}>Cancel</button>
                                    <button
                                      className='noteButton'
                                      type='button'
                                      onClick={this.addNoteSave.bind(this)}>Add Note</button>
                                  </div>
                                </div> :
                                <div style={{textAlign: 'center', marginBottom: '10px'}}>
                                  <button type='button' className='noteButton' onClick={this.toggleAddNote.bind(this)}>Add Note</button>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
              <div className='inclusionFilterWrapper' style={{ display: 'none' }}>
                <div className='includeTitle'>Additional Shared Information:</div>
                <div className='includeItemWrapper'>
                  <div className='includeItem'>
                    <div className='includeCheckbox'>
                      <RhinoCheckbox
                        selected={this.state.includeGia}
                        changeMethod={this.toggleIncludeGia.bind(this)} />
                    </div>
                    <div className='includeLabel'>GIA Number</div>
                  </div>
                  <div className='includeItem'>
                    <div className='includeCheckbox'>
                      <RhinoCheckbox
                        selected={this.state.includePrice}
                        changeMethod={this.toggleIncludePrice.bind(this)} />
                    </div>
                    <div className='includeLabel'>Price</div>
                  </div>
                  <div className='includeItem'>
                    <div className='includeCheckbox'>
                      <RhinoCheckbox
                        selected={this.state.includeImage}
                        changeMethod={this.toggleIncludeImage.bind(this)} />
                    </div>
                    <div className='includeLabel'>Image</div>
                  </div>
                  <div className='includeItem'>
                    <div className='includeCheckbox'>
                      <RhinoCheckbox
                        selected={this.state.includeVideo}
                        changeMethod={this.toggleIncludeVideo.bind(this)} />
                    </div>
                    <div className='includeLabel'>Video</div>
                  </div>
                </div>
              </div>
              <div className='shareButtonWrapper' style={{ display: 'none' }}>
                <button className={'shareCardButton actionButton'} disabled={this.state.selectedDiamonds.length === 0} onClick={this.openMessageModal.bind(this)}>Share with Customer</button>
                <button className={'shareCardButton actionButton'} disabled={this.state.selectedDiamonds.length === 0} onClick={this.transferAll.bind(this)}>Transfer All</button>
                <button className={'shareCardButton actionButton'} disabled={this.state.selectedDiamonds.length === 0} onClick={this.holdAll.bind(this)}>Hold All</button>
                {this.state.selectedDiamonds.length === 0 ?
                  <div className='shareInstructions'>Select at least one diamond to share, transfer, or hold</div> :
                  <div className='shareInstructions'>&nbsp;</div>
                }
              </div>
            </div>
          </div>
          <div className='leadDiamondsWrapper'>
            {this.state.diamondsData ?
              <div>
                {this.state.diamondsData.map((diamond, i) => {
                  return <div className={this.isSelected(diamond) ? 'diamondWrapper selected' : 'diamondWrapper'} key={i}>
                    <div className='diamondCheckboxWrapper'>
                      <div className={this.isSelected(diamond) ? 'favoriteWrapper favoriteSelected' : 'favoriteWrapper'} onClick={() => this.toggleSelected(diamond)}>
                        <img src='/img/diamonds/star.svg' className='notSelectedStar' />
                        <img src='/img/diamonds/star_fill.svg' className='selectedStar' />
                      </div>
                    </div>
                    <div className='diamondImageWrapper'>
                      <img src={getDiamondImage(diamond)} />
                    </div>
                    <div className='diamondBodyWrapper'>
                      <div className='diamondTitle'>{formatDiamondTitle(diamond)}</div>
                      <div className='diamondMeasurementRow'>
                        {diamond.measurements ? 
                          <div className='diamondMeasurements'>{formatMeasurements(diamond)}</div> :
                          null
                        }
                        <div className='diamondLocation'>
                          <div className='diamondLocationIcon'>
                            <i className="fas fa-map-marker-alt"></i>
                          </div>
                          <div className='diamondLocationName'>{formatLocation(diamond)}</div>
                        </div>
                      </div>
                      <div className='diamondMobileControls'>
                        <button className={'viewButton secondaryButton'} onClick={() => this.userNav('diamond/view/' + diamond.id)}>View</button>
                        <button className={'removeButton secondaryButton'} onClick={() => this.removeDiamond(diamond)}>Remove</button>
                      </div>
                      <div className='diamondInfoBlock'>
                        <div className='diamondInfoItem'>
                          <div className='diamondInfoLabel'>Cut:</div>
                          <div className={'diamondInfoValue EllipsisElement'}>{formatCut(diamond)}</div>
                        </div>
                        <div className='diamondInfoItem'>
                          <div className='diamondInfoLabel'>Lab:</div>
                          <div className={'diamondInfoValue EllipsisElement'}>{diamond.lab}</div>
                        </div>
                        <div className='diamondInfoItem'>
                          <div className='diamondInfoLabel'>Carat:</div>
                          <div className={'diamondInfoValue EllipsisElement'}>{formatCarat(diamond)}</div>
                        </div>
                        <div className='diamondInfoItem'>
                          <div className='diamondInfoLabel'>Cost:</div>
                          <div className={'diamondInfoValue EllipsisElement'}>{formatCost(diamond)}</div>
                        </div>
                        <div className='diamondInfoItem'>
                          <div className='diamondInfoLabel'>Color:</div>
                          <div className={'diamondInfoValue EllipsisElement'}>{formatColor(diamond)}</div>
                        </div>
                        <div className='diamondInfoItem'>
                          <div className='diamondInfoLabel'>Price:</div>
                          <div className={'diamondInfoValue EllipsisElement'}>{formatPrice(diamond)}</div>
                        </div>
                        <div className='diamondInfoItem'>
                          <div className='diamondInfoLabel'>Clarity:</div>
                          <div className={'diamondInfoValue EllipsisElement'}>{formatClarity(diamond)}</div>
                        </div>
                        <div className={'diamondInfoItem singleItem'}>
                          <div className={'diamondInfoLabel'}>{diamond.in_wallet ? 'Loose' : 'Mounted'}</div>
                          <div className={'diamondInfoValue EllipsisElement'}></div>
                        </div>
                      </div>
                    </div>
                    <div className='diamondControlsWrapper'>
                      <button className={'viewButton secondaryButton'} onClick={() => this.userNav('diamond/view/' + diamond.id)}>View</button>
                      <button className={'removeButton secondaryButton'} onClick={() => this.removeDiamond(diamond)}>Remove</button>
                    </div>
                  </div>
                })}
              </div> :
              null
            }
          </div>
          <div className='buttonWrapper'>
            <div className={'backToLeadsSubmit bottomAction'} onClick={() => this.userNav('leads')}>
              Back to Customers
            </div>
            <div className='bottomActionSpacer'></div>
          </div>
        </div>
      }
      <RhinoModal
        open={this.state.showShareModal}>
        <div className='shareModal'>
          <div className='closeModal' onClick={this.closeShareModal.bind(this)}>&times;</div>
          <div className='shareModalTitle'>
            {this.state.shareError ?
              <span>Error Sharing Diamonds</span> :
              <span>How would you like to share?</span>
            }
          </div>
          <div className='shareModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          {!this.state.externalShare && this.state.shareError === null ?
            <div className='shareIconLoading'>Loading...</div> :
            <div>
              {this.state.shareError ?
                <div>
                  <div className='shareModalErrorMessage'>{this.state.shareError}</div>
                  <div className={'shareModalErrorButton actionButton'} onClick={this.closeShareModal.bind(this)}>Close</div>
                </div> :
                <div className='shareIconWrapper'>

                  <div className='shareIcon' onClick={this.shareExternalSubmit.bind(this)}>
                    <img src='/img/icons/share/email.svg' />
                  </div>

                  <a href={'https://www.facebook.com/sharer/sharer.php?u=' + base_url + '/my-collection/' + this.state.externalShare.lookup_key} target="_blank" style={{display: 'none'}}>
                    <div className='shareIcon' onClick={this.closeShareModal.bind(this)}>
                      <img src='/img/icons/share/facebook.svg' />
                    </div>
                  </a>

                  <a href={'https://api.whatsapp.com/send?text=' + encodeURIComponent('Take a look at the hand-picked selection of diamonds for you: ' + base_url + '/my-collection/' + this.state.externalShare.lookup_key)} target="_blank">
                    <div className='shareIcon' onClick={this.closeShareModal.bind(this)}>
                      <img src='/img/icons/share/whatsapp.svg' />
                    </div>
                  </a>

                  <a href={'sms:?&body=' + encodeURIComponent('Take a look at the hand-picked selection of diamonds for you: ' + base_url + '/my-collection/' + this.state.externalShare.lookup_key)}>
                    <div className='shareIcon' onClick={this.closeShareModal.bind(this)}>
                      <img src='/img/icons/share/text.svg' />
                    </div>
                  </a>
                </div>
              }
            </div>
          }
        </div>
      </RhinoModal>
      <RhinoModal
        open={this.state.showMessageModal}>
        <div className='shareModal'>
          <div className='closeModal' onClick={this.closeMessageModal.bind(this)}>&times;</div>
          <div className='shareModalTitle'>Include an optional message?</div>
          <div className='shareModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          <div className='shareOptionalMessageWrapper'>
            <div className='messageInputWrapper'>
              <textarea className='messageInput' onChange={this.changeMessage.bind(this)} value={this.state.message} placeholder='Add message here'></textarea>
            </div>
            <div className='messageButtonWrapper'>
              <div className={'shareMessageButton actionButton'} onClick={this.openShareModal.bind(this)}>Share</div>
            </div>
          </div>
        </div>
      </RhinoModal>
      <RhinoModal
        open={this.state.holdModalOpen}>
        <div className='transferModal'>
        <div className='closeModal' onClick={this.closeHoldModal.bind(this)}>&times;</div>
          <div className='transferModalTitle'>Submit Hold Request</div>
          <div className='transferModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          <div className='transferModalInput'>
            <textarea
              type='text' 
              onChange={this.changeHoldMessage.bind(this)} 
              value={this.state.holdMessage}
              placeholder='Include an optional message'></textarea>
          </div>
          <div className='transferModalButton'>
            <button className={'actionButton transferButton'} onClick={this.sendHoldRequest.bind(this)}>Submit Request</button>
          </div>
        </div>
      </RhinoModal>
      <RhinoModal
        open={this.state.transferModalOpen}>
        <div className='transferModal'>
          <div className='closeModal' onClick={this.closeTransferModal.bind(this)}>&times;</div>
          <div className='transferModalTitle'>Submit Transfer Request</div>
          <div className='transferModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              onChange={this.changeTransferName.bind(this)}
              value={this.state.transferName}
              placeholder='Customer Name' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              onChange={this.changeTransferApptDate.bind(this)}
              value={this.state.transferApptDate}
              placeholder='Appointment Date*' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              onChange={this.changeTransferApptTime.bind(this)}
              value={this.state.transferApptTime}
              placeholder='Appointment Time' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              onChange={this.changeTransferBudget.bind(this)}
              value={this.state.transferBudget}
              placeholder='Estimated Budget' />
          </div>
          <div className='transferModalInput'>
            <textarea
              type='text' 
              onChange={this.changeTransferMessage.bind(this)}
              value={this.state.transferMessage}
              placeholder='Include an optional message'></textarea>
          </div>
          <div className='transferModalButton'>
            <button className={'actionButton transferButton'} onClick={this.sendTransferRequest.bind(this)}>Submit Request</button>
          </div>
        </div>
      </RhinoModal>
      <RhinoModal open={this.state.editModalOpen}>
        <div className='transferModal'>
        <div className='closeModal' onClick={this.closeEditModal.bind(this)}>&times;</div>
          <div className='transferModalTitle'>Edit Note</div>
          <div className='transferModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          <div className='transferModalInput'>
            <textarea
              type='text' 
              onChange={this.changeNoteBody.bind(this)} 
              value={this.state.noteBody}
              placeholder='Edit note here'></textarea>
          </div>
          <div className='transferModalButton'>
            <button className={'actionButton transferButton'} onClick={this.handleEdit.bind(this)}>Save</button>
          </div>
        </div>
      </RhinoModal>
      <RhinoConfirm
        confirmText='Are you sure you want to delete this note?'
        confirmMethod={this.handleDelete.bind(this)}
        cancelMethod={this.closeDeleteModal.bind(this)}
        open={this.state.deleteModalOpen} />
    </div>;
  }
}
export default SingleLead;

function mapStateToProps(state) {
  return {
    leads: state.leads,
  };
}

export const SingleLeadContainer = connect(
  mapStateToProps,
  allActionCreators
)(SingleLead);